import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import CountUp from 'react-countup';
//redux
import { useSelector, useDispatch } from "react-redux";

import getChartColorsArray from "components/_Common/ChartsDynamicColor";

const WalletBalance = ({ dataColors, analyticData, getAnalyticData }) => {
  const dispatch = useDispatch();
  const date = new Date();
  const monthNumber = date.getMonth() + 1; 
  const currentYear = date.getFullYear();
  const [monthSelect, setMonthSelect] = useState(monthNumber)

  const walletBalanceChartColors = getChartColorsArray(dataColors);

  const seriesPrevious =  [analyticData?.previous_precentage?.pending || 0, analyticData?.previous_precentage?.inprogress || 0, analyticData?.previous_precentage?.complete || 0];
  const seriesCurrent =  [analyticData?.current_precentage?.pending || 0, analyticData?.current_precentage?.inprogress || 0,  analyticData?.current_precentage?.complete || 0];
  function formatNumber(num) {
    // Convert to string and remove leading zeros
    num = parseFloat(num.toString());
  
    // Format to two decimal places if less than 100
    if (num < 100) {
      return num.toFixed(2);
    }
    return num.toString();
  }
  
  const previousOptions = {
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "35%",
          background: "transparent",
          image: void 0,
        },
        track: {
          show: !0,
          startAngle: void 0,
          endAngle: void 0,
          background: "#f2f2f2",
          strokeWidth: "97%",
          opacity: 1,
          margin: 12,
          dropShadow: {
            enabled: !1,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        },
        dataLabels: {
          name: {
            show: !0,
            fontSize: "16px",
            fontWeight: 600,
            offsetY: -10,
          },
          value: {
            show: !0,
            fontSize: "14px",
            offsetY: 4,
            formatter: function (e) {
              return e + "%";
            },
          },
          total: {
            show: !0,
            label: "Complete",
            color: "#373d3f",
            fontSize: "16px",
            fontFamily: void 0,
            fontWeight: 600,
            formatter: function (e) {
              return `${formatNumber(e.globals.seriesTotals[2])}%`;
              // return (
              //   e.globals.seriesTotals.reduce(function (e, t) {
              //     return e + t;
              //   }, 0) + "%"
              // );
            },
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    colors: walletBalanceChartColors,
    labels: ["Pending", "In Progress", "Complete"],
    legend: { show: !1 },
  };

  const currentOptions = {
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "35%",
          background: "transparent",
          image: void 0,
        },
        track: {
          show: !0,
          startAngle: void 0,
          endAngle: void 0,
          background: "#f2f2f2",
          strokeWidth: "97%",
          opacity: 1,
          margin: 12,
          dropShadow: {
            enabled: !1,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        },
        dataLabels: {
          name: {
            show: !0,
            fontSize: "16px",
            fontWeight: 600,
            offsetY: -10,
          },
          value: {
            show: !0,
            fontSize: "14px",
            offsetY: 4,
            formatter: function (e) {
              return e + "%";
            },
          },
          total: {
            show: !0,
            label: "Complete",
            color: "#373d3f",
            fontSize: "16px",
            fontFamily: void 0,
            fontWeight: 600,
            formatter: function (e) {
              return `${formatNumber(e.globals.seriesTotals[2])}%`;
              // return (
              //   e.globals.seriesTotals.reduce(function (e, t) {
              //     return e + t;
              //   }, 0) + "%"
              // );
            },
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    colors: walletBalanceChartColors,
    labels: ["Pending", "In Progress", "Complete"],
    legend: { show: !1 },
  };

  const onSelectMonth = (month) => {
    setMonthSelect(month)
    getAnalyticData(`/${month}/${currentYear}`)
  }

  return (
    <React.Fragment>
      {/* <Col xl="8"> */}
        <Card>
        <div className="monthly-earning-chart survey-record">
            <h3 className="survey-title card-title">Survey</h3>
              <div className="float-end mb-4">
                <select value={monthSelect} className="form-select form-select-sm ms-2" onChange={(e) => onSelectMonth(e.target.value)}>
                  <option value="1">January {currentYear}</option>
                  <option value="2">February {currentYear}</option>
                  <option value="3">March {currentYear}</option>
                  <option value="4">April {currentYear}</option>
                  <option value="5">May {currentYear}</option>
                  <option value="6">June {currentYear}</option>
                  <option value="7">July {currentYear}</option>
                  <option value="8">August {currentYear}</option>
                  <option value="9">September {currentYear}</option>
                  <option value="10">October {currentYear}</option>
                  <option value="11">November {currentYear}</option>
                  <option value="12">December {currentYear}</option>
                </select>
              </div>
            <Row className="mb-4 w-100">
              <Col lg="2">
                <h4 className="card-title mb-4">Difference</h4>
                <div className="mt-1 survey-show">
                  <span><b>Pending </b></span>
                  <span style={{marginLeft:'2px'}} className="text-muted mb-4">
                  <CountUp decimals={2} end={analyticData?.difference?.pending} />%
                    {
                      Number(analyticData?.difference?.pending) == 0 
                      ? <span style={{color:'green', marginLeft: '2px', fontWeight: 'bold'}}>--</span>
                      :
                      <i style={{color: `${Number(analyticData?.difference?.pending) < 0 ? 'red' : 'green'}`}} className={`mdi mdi-arrow-${Number(analyticData?.difference?.pending) < 0 ? 'down' : 'up'} ms-1 `} />

                    }
                  </span>
                </div>
                <div className="mt-1 survey-show">
                  <span><b>In Progress </b></span>
                  <span style={{marginLeft:'2px'}} className="text-muted mb-4">
                    <CountUp decimals={2} end={analyticData?.difference?.inprogress} />%
                    {
                      Number(analyticData?.difference?.inprogress) == 0 
                      ? <span style={{color:'green', marginLeft: '2px', fontWeight: 'bold'}}>--</span>
                      :
                      <i style={{color: `${Number(analyticData?.difference?.inprogress) < 0 ? 'red' : 'green'}`}} className={`mdi mdi-arrow-${Number(analyticData?.difference?.inprogress) < 0 ? 'down' : 'up'} ms-1 `} />

                    }
                  </span>
                </div>
                <div className="mt-1 survey-show">
                  <span><b>Complete </b></span>
                  <span style={{marginLeft:'2px'}} className="text-muted mb-4">
                    <CountUp decimals={2} end={analyticData?.difference?.complete} />%
                    {
                      Number(analyticData?.difference?.complete) == 0 
                      ? <span style={{color:'green', marginLeft: '2px', fontWeight: 'bold'}}>--</span>
                      :
                      <i style={{color: `${Number(analyticData?.difference?.complete) < 0 ? 'red' : 'green'}`}} className={`mdi mdi-arrow-${Number(analyticData?.difference?.complete) < 0 ? 'down' : 'up'} ms-1 `} />

                    }
                  </span>
                </div>
              </Col>

              <Col lg="5" sm="5">
                <div>
                  <h4 className="card-title mb-3 text-center">Previous Month</h4>
                  <div id="wallet-balance-chart">
                    <ReactApexChart
                      options={previousOptions}
                      series={seriesPrevious}
                      type="radialBar"
                      height={300}
                      className="apex-charts"
                    />
                    <div className="survey-diff">
                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-primary" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.previous_precentage?.pending || 0} />% Pending</b>
                        </p>
                      </div>

                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-warning" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.previous_precentage?.inprogress || 0} />% In Progress</b>
                        </p>
                      </div>

                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-info" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.previous_precentage?.complete || 0} />% Complete</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg="5" sm="5">
                <div>
                <h4 className="card-title mb-3 text-center">Current Month</h4>
                  <div id="wallet-balance-chart">
                    <ReactApexChart
                      options={currentOptions}
                      series={seriesCurrent}
                      type="radialBar"
                      height={300}
                      className="apex-charts"
                    />
                    <div className="survey-diff">
                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-primary" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.current_precentage?.pending || 0} />% Pending</b>
                        </p>
                      </div>

                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-warning" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.current_precentage?.inprogress || 0} />% In Progress</b>
                        </p>
                      </div>

                      <div className="survey-figure">
                        <p className="mb-2">
                          <i className="mdi mdi-circle align-middle font-size-10 me-2 text-info" />{" "}
                          <b><CountUp decimals={2} end={analyticData?.current_precentage?.complete || 0} />% Complete</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      {/* </Col> */}
    </React.Fragment>
  );
};

export default WalletBalance;
